import styled, { keyframes } from "styled-components";

const hurtShake = keyframes`
  0%, 100% { transform: translateX(0); }
  25%      { transform: translateX(-4px); }
  75%      { transform: translateX(4px); }
`;

export const Bottom = styled.div`
  position: relative;
  height: 110px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 20px;
  padding: 0 32px;
  background: linear-gradient(0deg, rgba(6, 7, 10, 0.95) 0%, rgba(6, 7, 10, 0.6) 70%, transparent 100%);
  backdrop-filter: blur(6px);
  z-index: 2;
`;

export const Health = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 10px 14px;
  background: var(--panel);
  border: 1px solid var(--border);
  border-radius: 10px;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.03);
  transition: border-color 0.2s ease;

  img {
    width: 22px;
    height: 22px;
    transition: filter 0.2s ease, transform 0.2s ease;
    filter: drop-shadow(0 0 6px var(--danger-glow));
  }

  &.hurt {
    animation: ${hurtShake} 0.35s ease-in-out;
    border-color: var(--danger);
    box-shadow: 0 0 18px var(--danger-glow);
  }
`;

export const Word = styled.div`
  background: var(--panel);
  border: 1px solid var(--border-strong);
  border-radius: 12px;
  display: flex;
  align-items: center;
  gap: 8px;
  color: var(--text-faint);
  padding: 14px 24px;
  text-transform: lowercase;
  font-family: 'JetBrains Mono', monospace;
  font-size: 22px;
  font-weight: 600;
  letter-spacing: 2px;
  min-width: 280px;
  height: 56px;
  text-align: center;
  justify-content: center;
  box-shadow:
    0 4px 14px rgba(0, 0, 0, 0.5),
    inset 0 1px 0 rgba(255, 255, 255, 0.03);

  .letter {
    transition: color 0.1s linear, text-shadow 0.1s linear;
  }
`;

export const Restart = styled.div`
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  cursor: pointer;
  background: var(--panel);
  border: 1px solid var(--border);
  transition: all 0.2s ease;

  svg path {
    stroke: var(--text-dim);
    transition: stroke 0.2s ease;
  }

  &:hover {
    border-color: var(--accent);
    background: var(--panel-2);
    transform: rotate(-90deg);

    svg path {
      stroke: var(--accent);
    }
  }
`;
